<template>
    <div>

        <div style="height: 400px">
            <el-form :model="$parentInfo.Dialog_CreateClassPackage.classPackage"
                     label-width="90px">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="套餐名">
                            <el-input v-model="$parentInfo.Dialog_CreateClassPackage.classPackage.name"
                                      placeholder="请输入套餐名"
                                      class="inputWidth"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="类型">
                        <el-select v-model="$parentInfo.Dialog_CreateClassPackage.classPackage.type"
                                   remote
                                   clearable
                                   placeholder="请选择类型"
                                   class="inputWidth">
                            <el-option
                                    v-for="item in $parentInfo.types"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="总介绍">
                            <el-input v-model="$parentInfo.Dialog_CreateClassPackage.classPackage.remark"
                                      placeholder="请输入总介绍"
                                      type="textarea"
                                      class="inputWidth"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="适合对象">
                            <el-input v-model="$parentInfo.Dialog_CreateClassPackage.classPackage.suitable_for_student"
                                      placeholder="请输入适合对象"
                                      type="textarea"
                                      class="inputWidth"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                    <el-form-item label="问题呈现">
                        <el-input v-model="$parentInfo.Dialog_CreateClassPackage.classPackage.problemPresented"
                                  placeholder="请输入问题呈现"
                                  type="textarea"
                                  class="inputWidth"></el-input>
                    </el-form-item>
                    </el-col>
                    <el-col :span="12">
                    <el-form-item label="解决方案">
                        <el-input v-model="$parentInfo.Dialog_CreateClassPackage.classPackage.solution"
                                  placeholder="请输入解决方案"
                                  type="textarea"
                                  class="inputWidth"></el-input>
                    </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="课程安排">
                            <el-input v-model="$parentInfo.Dialog_CreateClassPackage.classPackage.curriculum"
                                      placeholder="请输入课程安排"
                                      type="textarea"
                                      class="inputWidth"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                    <el-form-item label="班主任">
                        <el-input v-model="$parentInfo.Dialog_CreateClassPackage.classPackage.headTeacher_name"
                                  placeholder="请输入班主任"
                                  type="textarea"
                                  class="inputWidth"></el-input>
                    </el-form-item>
                    </el-col>
                    <el-col :span="12">
                    <el-form-item label="班主任电话">
                        <el-input v-model="$parentInfo.Dialog_CreateClassPackage.classPackage.headTeacher_phone"
                                  placeholder="请输入班主任电话"
                                  type="textarea"
                                  class="inputWidth"></el-input>
                    </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
        </div>
        <div class=" text-right">
            <el-button type="primary" @click="handleStoreClassPackage"
                       :loading="$parentInfo.Dialog_CreateClassPackage.button_loading">保 存
            </el-button>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'Dialog_CreateClassPackage',
        data() {
            return {

            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            },
        },
        methods: {
            handleStoreClassPackage() {
                this.$parentInfo.Dialog_CreateClassPackage.button_loading=true;

                this.$wApi.send(this.$parentInfo.path, 'store_classPackage', {
                    name:this.$parentInfo.Dialog_CreateClassPackage.classPackage.name,
                    suitable_for_student:this.$parentInfo.Dialog_CreateClassPackage.classPackage.suitable_for_student,
                    remark:this.$parentInfo.Dialog_CreateClassPackage.classPackage.remark,
                    class_features:this.$parentInfo.Dialog_CreateClassPackage.classPackage.class_features,
                    curriculum:this.$parentInfo.Dialog_CreateClassPackage.classPackage.curriculum,
                    problemPresented:this.$parentInfo.Dialog_CreateClassPackage.classPackage.problemPresented,
                    solution:this.$parentInfo.Dialog_CreateClassPackage.classPackage.solution,
                    headTeacher_name:this.$parentInfo.Dialog_CreateClassPackage.classPackage.headTeacher_name,
                    headTeacher_phone:this.$parentInfo.Dialog_CreateClassPackage.classPackage.headTeacher_phone,
                    type:this.$parentInfo.Dialog_CreateClassPackage.classPackage.type
                });
            },

        }
    }
</script>

<style scoped lang="scss">
    .card-body {
        height: calc(100vh - 125px);
    }

    .card-footer {
        position: fixed;
        width: calc(100% - 20px);
        padding: 5px 10px;
        bottom: 0;
    }

    .inputWidth {
        width: 250px !important;
    }
</style>
